import React from "react";

interface GradientButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: "primary" | "secondary" | "submit";
  className?: string;
}

export const GradientButton: React.FC<GradientButtonProps> = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  variant = "primary",
}) => {
  if (variant === "submit") {
    return (
      <div
        className="button-primary-gradient main-submit-link-container">
        <button
          type={type}
          disabled={disabled}
          onClick={onClick}
          className="button-primary form-submit-button main-button-link"
        >
          {children}
        </button>
        <div className="main-submit-link-blur"></div>
      </div>
    );
  }

  return (
    <div className="button-primary-gradient">
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={variant === "primary" ? "button-primary" : "btn-secondary"}
      >
        {children}
      </button>
    </div>
  );
};
